import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ProjectEditDialogComponent } from '../project/project-edit/project-edit.dialog.component';
import { Project } from '../../../core/auth/_models/project.model';
@Component({
  selector: 'pre-build-tier-information-dialog',
  templateUrl: './PreBuildTierInformation.component.html',
  styleUrls: ['./PreBuildTierInformation.component.scss'],
})
export class PreBuildTierInformationDialogComponent implements OnInit {
  selectedItems: any[]; // Define a property to hold the selected items
  selectedItemsWithDetails: any[];
  matchingNodeTextArray: string[] = [];
  showExtractedTexts: boolean = false;
  selectedPreBuildTierName: string = '';
  
  constructor(
    private dialogRef: MatDialogRef<PreBuildTierInformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any, // Inject MAT_DIALOG_DATA to access the passed data
    private dialog: MatDialog // Inject MatDialog to open the ProjectEditDialogComponent
  ) {
    // Assign the selected items from the passed data to the component property
    this.selectedItems = data.selectedItems;
    this.selectedItemsWithDetails = data.selectedItemsWithDetails;
  }

  ngOnInit(): void {
    // Initialization code if needed
    console.log("this.selectedItems", this.selectedItems);

  }

  ok(): void {
    // Open ProjectEditDialogComponent and pass selectedItems when OK is clicked
    const dialogRef = this.dialog.open(ProjectEditDialogComponent, {
      data: {
        preBuildTier: true,
        selectedItems: this.selectedItems // Pass selectedItems data to ProjectEditDialogComponent
      },
      height: '95%',
      width: '90%'
    });

    dialogRef.afterClosed().subscribe((result: Project) => {
      if (result) {
        // Handle the result returned from the dialog
      }
    });

    this.dialogRef.close(); // Close the current dialog
  }

  cancel(): void {
    this.dialogRef.close(); // Close the dialog without passing any data back
  }
  handleRowClick(selectedItemIndex: number, preBuildTierName: string): void {
    console.log("Clicked row index:", selectedItemIndex);
    // Access the selected item
    this.selectedPreBuildTierName = preBuildTierName;
    console.log("preBuildTierName",preBuildTierName);
    const selectedItem = JSON.parse(this.selectedItems[selectedItemIndex]);
    // Filter out "Base Frame" item from the nodeDataArray and extract only the "text" property
    this.matchingNodeTextArray = selectedItem.nodeDataArray
      .filter(item => item.text !== "Base Frame")
      .map(item => item.text);
    console.log("Matching node text array:", this.matchingNodeTextArray);
    // Show the extracted texts section
    this.showExtractedTexts = true;
  }
}
